// Single source of truth for the user-facing product version shown in the
// Navbar and anywhere else we display a version label. Bump this on every
// production release so marketing copy, the help page, and support
// screenshots all read the same number. This is DIFFERENT from package.json
// semver (which stays at 0.1.0 because we don't publish to npm).
export const APP_VERSION = "4.2";
